import { observable, makeObservable } from 'mobx'

class SurveyUser {
    @observable checked = false

    constructor({
        clientid,
        companyname,
        email,
        salutation,
        emailsent,
        firstname,
        lastname,
        jobtitle,
        listname,
        optout,
        sdstatus,
        surveyuserid_txt,
        emailsubject,
        type = 1,
        surveyuserlistId,
    }) {
        makeObservable(this)
        console.log(`SurveyUser ${email} ${firstname}`)
        this.clientid = clientid
        this.companyname = companyname
        this.salutation = salutation
        this.email = email
        this.emailsent = emailsent
        this.firstname = firstname
        this.lastname = lastname
        this.jobtitle = jobtitle
        this.listname = listname
        this.optout = optout
        this.sdstatus = sdstatus
        this.emailsubject = emailsubject
        this.surveyuserid_txt = surveyuserid_txt
        this.type = type
        this.surveyuserlistId = surveyuserlistId
    }

    toJSON() {
        return {
            email: this.email,
            salutation: this.salutation,
            firstname: this.firstname,
            lastname: this.lastname,
            companyname: this.companyname,
            jobtitle: this.jobtitle,
            type: this.type,
            surveyuserlistname: this.surveyuserlistname,
            surveyuserlistId: this.surveyuserlistId,
        }
    }
}

export {
    SurveyUser,
}
